import {AxiosResponse} from 'axios';
import React, {useState, useEffect, useRef} from 'react';

import NewBrandIcon from '@/assets/banner/new-brand-icon.svg';
import {useDebouncedEffect} from '@/hooks/useDebounceEffect';
import {fetchBrands} from '@/services/community';

import FilterModalHeader from '../FilterModal/FilterModalHeader';

interface Props {
  select: (sc: BrandInfo) => void;
  isOpen: boolean;
  togglePopup: (is: boolean) => void;
}

export default function BrandModal({select, isOpen, togglePopup}: Props) {
  const [toggledBrand, setToggledBrand] = useState<BrandInfo>();
  const [search, setSearch] = useState<string>('');
  const [brands, setBrands] = useState<BrandInfo[]>([]);
  const newBrandItem: BrandInfo = {
    address: '',
    brandLink: '',
    brandImages: [],
    categoryList: [],
    hashtags: [],
    id: -1,
    info: null,
    openingHours: '',
    points: [],
    productName: '',
    state: '',
    thumbnailUrl: '',
    title: '',
    type: '',
    whereToBuy: '',
    parentId: undefined,
  };
  const wrapperRef = useRef<HTMLDivElement>(null);
  const handleChange = ($event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch($event.currentTarget.value);
  };
  const clickNewBrand = () => {
    const item = {...newBrandItem};
    item.title = search;
    setToggledBrand(item);
    // select(item);
  };
  const complete = () => {
    console.log(toggledBrand);
    select(toggledBrand as BrandInfo);
    togglePopup(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const handleClickOutside = (event: any) => {
    if (wrapperRef && !wrapperRef?.current?.contains(event.target)) {
      togglePopup(false);
    }
  };

  useDebouncedEffect(
    async () => {
      if (search && search.length > 0) {
        const res: AxiosResponse<BrandInfo[]> = await fetchBrands(search);
        setBrands(res.data);
      } else {
        setBrands([]);
      }
    },
    500,
    [search],
  );

  return (
    <div className="modal-wrapper" style={{display: isOpen ? 'flex' : 'none'}}>
      <div
        className={`modal-contents category ${isOpen ? 'active' : ''}`}
        ref={wrapperRef}>
        <FilterModalHeader
          txt={'브랜드명 검색'}
          fnTxt="초기화"
          close={() => togglePopup(false)}
        />
        <div className="brand-modal-body">
          <div className="search-wrapper">
            <input
              type="text"
              placeholder="브랜드명을 입력하세요"
              onChange={handleChange}
            />
            <span className="icon search-gray-icon">&nbsp;</span>
          </div>
          <ul
            className="search-result"
            style={{display: search && search.length > 0 ? 'block' : 'none'}}>
            <li
              className={`${toggledBrand?.id === -1 ? 'active' : ''}`}
              onClick={() => clickNewBrand()}>
              <span
                className="brand-logo"
                style={{
                  background: `url(${NewBrandIcon}) no-repeat center / cover`,
                }}></span>
              <span className="brand-title-wrapper">
                <span className="brand-title">{`‘${search}’`}</span>신규 브랜드
                추가
              </span>
            </li>
            {brands.length > 0 &&
              brands.map(brand => {
                return (
                  <li
                    className={`${
                      toggledBrand?.id === brand.id ? 'active' : ''
                    }`}
                    key={`modal-category-${brand.id}`}
                    onClick={() => setToggledBrand(brand)}>
                    <span
                      className="brand-logo"
                      style={{
                        background: `url(${brand.thumbnailUrl}) no-repeat center / cover`,
                      }}></span>
                    <span className="brand-title">{brand.title}</span>
                    {/**
                    <span className="brand-category">
                      {brand.categoryList
                        ? brand.categoryList.join(' ∙ ').replaceAll(' / ', '/')
                        : ''}
                    </span>
                    */}
                  </li>
                );
              })}
          </ul>
        </div>
        <div className="filter-modal-footer">
          <button
            className="modal btn black-filled"
            disabled={!toggledBrand}
            onClick={() => complete()}
            style={{background: !toggledBrand ? '#E9E7EC' : '#000'}}>
            선택 완료
          </button>
          <button
            className="modal btn empty"
            onClick={() => togglePopup(false)}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
}
